// extracted by mini-css-extract-plugin
export default {"mainDiv":"TermsConditions_mainDiv__iIJFq","buttonSection":"TermsConditions_buttonSection__f8Zkc"};